import { DEFAULT_CHILDREN } from '../constants';

/**
 * Fix children for excerpt.
 * @param {[{ text: string, children: array }]} children
 * @returns {[{text: string}]|*}
 */
const fixChildren = (children) => (children?.length === 0
  ? DEFAULT_CHILDREN : children.filter((child) => !child.children
      || child.children?.length > 0));

const fixExcerpt = (content) => {
  if (!content?.length) {
    return content;
  }

  const prepareContent = content.map((item) => {
    const { children } = item;

    return {
      ...item,
      children: fixChildren(children),
    };
  });

  return prepareContent;
};

export default fixExcerpt;
